// DS: CO1.3
import React from 'react';
import c from 'classnames';
import { PapiBadge } from '@wix/da-papi-types';
import Badge from '@wix/da-ds/pkg/Badge';
import { showBadgeInfoModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';

import s from './SpotlightBadge.scss';

export interface Props {
  className?: string;
  badge: PapiBadge;
  username: string;
  showModal: typeof showBadgeInfoModal;
}

const SpotlightBadge: React.FC<Props> = ({
  className,
  badge,
  username,
  showModal,
}) => {
  const badge_page = useFlag('badge_page');
  return (
    <div
      className={c(s['root'], className)}
      onClick={badge_page ? () => showModal(username, badge.id!) : undefined}
    >
      <Badge className={s['badge']} badge={badge} size={68} type="huge" />
      <div className={s['blur']} />
      <div className={s['title']}>{badge.baseTitle}</div>
    </div>
  );
};
SpotlightBadge.displayName = 'SpotlightBadge';

export default SpotlightBadge;
